'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamPlayer = require('./CamPlayer');

var _CamPlayer2 = _interopRequireDefault(_CamPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamPlayer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamPlayer/index.js
// module id = 540
// module chunks = 11